import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import {
  CriarPessoaJuridica,
  type TCreateContaResponse,
  type TCreatePessoaJuridicaData,
} from '@/features/proposta/services/criar-pessoa-juridica.service'

export const useMutationCadastrarPessoaJuridica = () => {
  return useMutation<TCreateContaResponse, AxiosError<string[]>, TCreatePessoaJuridicaData>({
    mutationFn: async (pessoaJuridica: TCreatePessoaJuridicaData) => {
      const response = await new CriarPessoaJuridica().execute(pessoaJuridica)
      return response
    },
  })
}
